import { render } from "./AGB.vue?vue&type=template&id=2633941b&scoped=true"
import script from "./AGB.vue?vue&type=script&lang=js"
export * from "./AGB.vue?vue&type=script&lang=js"

import "./AGB.vue?vue&type=style&index=0&id=2633941b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2633941b"]])

export default __exports__